import { render, staticRenderFns } from "./MaterialEditTabBasic.vue?vue&type=template&id=6d2a3ccb&"
import script from "./MaterialEditTabBasic.vue?vue&type=script&lang=js&"
export * from "./MaterialEditTabBasic.vue?vue&type=script&lang=js&"
import style0 from "./MaterialEditTabBasic.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports